import React from 'react'

import DeviceStatusComponent from '../Components/DeviceStatus/DeviceStatusComponent'
import { useVisibleDevices } from '@data/device/device'

const DeviceStatus: React.FC = () => {
  const devices = useVisibleDevices()

  return (
    <div>
      <DeviceStatusComponent devices={devices} />
    </div>
  )
}

export default DeviceStatus
